import React, { useEffect, useState } from "react";
import SoftBox from "../SoftBox";
import SoftTypography from "../SoftTypography";

const clocks = [
  { label: "UTC", zone: "UTC", title: "Coordinated Universal Time" },
  { label: "CET", zone: "Europe/Paris", title: "Central European time (includes daylight saving)" },
  { label: "GST", zone: "Asia/Dubai", title: "Gulf Standard Time" },
];

/** Live reference clocks, matching the admin portal's fixed zones and one-second refresh. */
export default function TimeDisplay() {
  const [currentTime, setCurrentTime] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <SoftBox
      component="aside"
      aria-label="Time reference"
      sx={({ palette }) => ({
        display: "flex",
        justifyContent: "center",
        flexBasis: { xs: "100%", md: "auto" },
        order: { xs: 1, md: 0 },
        mb: { xs: 1, md: 0 },
        py: 0.75,
        px: 1.25,
        border: "1px solid " + palette.grey[300],
        borderRadius: "10px",
        backgroundColor: palette.white.main,
        "& > div + div": { borderLeft: "1px solid " + palette.grey[300] },
      })}
    >
      {clocks.map(({ label, zone, title }) => (
        <SoftBox
          key={zone}
          title={title}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          alignItems="center"
          gap={{ xs: 0.25, sm: 0.75 }}
          px={1}
        >
          <SoftTypography
            component="span"
            variant="caption"
            color="text"
            sx={{ fontSize: 10, fontWeight: 600 }}
          >
            {label}
          </SoftTypography>
          <SoftTypography
            component="time"
            dateTime={currentTime.toISOString()}
            variant="caption"
            sx={({ typography }) => ({
              fontFamily: typography.monoFontFamily,
              fontSize: 12,
              fontVariantNumeric: "tabular-nums",
            })}
          >
            {currentTime.toLocaleTimeString("en-GB", {
              timeZone: zone,
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })}
          </SoftTypography>
        </SoftBox>
      ))}
    </SoftBox>
  );
}
